@if (pending()) {
    <button type="button" class="banner" (click)="apply()">
        <app-icon name="circle-info" />
        <span>{{ 'update.ready' | translate }}</span>
        <span class="action">{{ 'update.install' | translate }}</span>
    </button>
}
